module.exports = __webpack_public_path__ + "img/Urdu.5e1bd12a.jpg";